import React from 'react';

export const VitaminIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="41"
    height="33"
    viewBox="0 0 41 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.382 24.539C16.7565 29.2119 5.84025 26.2494 1 17.922L16.618 9.461M25.382 24.539L16.618 9.461M25.382 24.539C30.4139 21.813 33.5546 17.0907 34.3373 11.9758M16.618 9.461L32.2359 0.999981C34.2526 4.46944 34.8963 8.32277 34.3373 11.9758M16.618 9.461L10.0169 24.6022M16.618 9.461L34.3373 11.9758"
      stroke="url(#paint0_linear)"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3269 17.7468C17.6358 17.7356 17.8749 17.4365 17.861 17.0787C17.8566 16.9649 17.8271 16.8588 17.779 16.7675L17.7735 16.7574L17.3646 15.8554C17.3202 15.7574 17.1792 15.7625 17.1425 15.8635L16.8048 16.7925L16.8001 16.803C16.7592 16.8975 16.738 17.0054 16.7425 17.1192C16.7564 17.477 17.018 17.758 17.3269 17.7468Z"
      stroke="url(#paint1_linear)"
    />
    <path
      d="M27.8083 7.53501C27.7478 7.24245 27.404 7.06211 27.0403 7.1322C26.9247 7.15449 26.821 7.19942 26.7352 7.25975L26.7258 7.26664L25.8798 7.79257C25.7866 7.85052 25.8161 7.99325 25.9252 8.0122L26.9155 8.18415L26.927 8.187C27.0302 8.21091 27.1438 8.21395 27.2594 8.19166C27.6231 8.12156 27.8688 7.82757 27.8083 7.53501Z"
      stroke="url(#paint2_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="14.3455"
        y1="24.7029"
        x2="27.3862"
        y2="0.962489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="16.9991"
        y1="17.1243"
        x2="17.9828"
        y2="16.9316"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="27.224"
        y1="7.94625"
        x2="26.9038"
        y2="7.02788"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
    </defs>
  </svg>
);
